import { connect } from 'react-redux';
import { trackCard } from 'services/insights';
import CardCta from './view';

const mapDispatchToProps = dispatch => ({
  onEngage: (doc, extra) => dispatch(trackCard('engage', doc, extra)),
});
export default connect(null, mapDispatchToProps)(CardCta);
